import {useCurrentRoute} from '~/CreateFabricInvitation/navigation';
import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';
import {isInDesktopStep1UpsellABTest, isInMwStep1UpsellABTest} from '../experiments';

// Experiment name: "test_step1_upsell_copy_desktop" and "exp-test_step1_upsell_copy_mw" - clean up ticket: EVT-35329
export const useInStep1UpsellCopyAbTest = () => {
  const isLargishAndUp = useIsLargishAndUp();
  const currentRoute = useCurrentRoute();
  const isStep1 = currentRoute?.name === 'customize' && !currentRoute?.meta?.editing;

  if (!isStep1) {
    return false;
  }

  if (isLargishAndUp) {
    return isInDesktopStep1UpsellABTest();
  }
  return isInMwStep1UpsellABTest();
};
